import React from 'react'
import ProductCategoryAddFeature from 'features/product-category/product-category-add.feature'

export default function ProductCategoryAddPage() {
  return <ProductCategoryAddFeature />
}
